module.exports = __webpack_public_path__ + "img/cross.8cf3234c.svg";